import _ from 'underscore';

import {TranslationAttributes} from 'biojs/Translation';
import * as MapsConstants from 'constants/MapsConstants';
import * as mapsutil from 'molbio/maps/MapsUtil';
import * as selectables from 'molbio/maps/selectables/Selectables';
import * as sequtil from 'molbio/SeqUtil';
import Translation from 'molbio/translations/backbone/Translation';

class Translations extends selectables.Collection<Translation> {
  static initClass(): void {
    this.prototype.model = Translation;
  }

  batchName(): string {
    return 'translations';
  } // should match biojs/translation.js

  initialize(): void {
    this.setLayers = this.batch(this.setLayers.bind(this));
    return this.on('add remove reset', () => {
      this.setLayers();
    });
  }

  slice(start: number, end: number): Array<Translation> {
    const data = this.filter((translation) => {
      const tStart = translation.start();
      const tEnd = translation.end();
      return sequtil.isRangeOverlap(start, end, tStart, tEnd);
    });

    return _.sortBy(data, (translation) => {
      const x1 = Math.max(start, translation.start());
      const x2 = Math.min(end, translation.end());
      return x1 - x2;
    });
  }

  setLayers(): void {
    const modelsAndLayers = mapsutil.getModelLayers(this.models, {top: false});
    for (const {model, layer} of modelsAndLayers) {
      model.set(MapsConstants.LINEAR_LAYER_FULL, layer, {silent: true});
    }
    this.trigger('layerChange');
  }

  toReactJSON(): Array<TranslationAttributes> {
    return this.models.map((m) => m.toReactDict());
  }
}
Translations.initClass();

export default Translations;
